import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import interceptorSetup from "@/_http/index";

Vue.config.productionTip = false;
interceptorSetup();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
